import { React, useState, useEffect, useContext } from 'react'
import { CCard, CCol, CRow, CImage } from '@coreui/react'
import { cilPencil, cilShare, cilShareAll, cilShareAlt, cilTrash } from '@coreui/icons'
import AddIcon from '../../../assets/add-icon.svg'
import CIcon from '@coreui/icons-react'
// import WebsiteTemplateModal from './websiteTemplateModal'
// import TemplateNameModal from './templateNameModal'
import { useHistory } from 'react-router-dom'
import useAxios from 'axios-hooks'
import { AppContext } from '../../context/app'
import { checkPermissions, createPageUrl, isEmpty, raiseToast } from 'src/views/utils/helper'
import { Dropdown } from 'react-bootstrap'
import OptionsBtn from '../../../assets/options-toggle-btn.svg'
import DeleteModal from 'src/components/DeleteModal/DeleteModal'
import CustomImage from 'src/components/customImage/customImage'
import ServiceNotAllowed from '../serviceNotAllowed'
import CustomPageNameModal from './customPageNameModal'
import { CUSTOM_PAGES_API } from 'src/views/utils/urls'
import moment from 'moment'
import ShareModal from 'src/components/shareModal'
import { GlobalContext } from 'src/views/context/GlobalState'
import { PERMISSIONS } from 'src/views/utils/permissions'

const CustomPageListing = () => {
  const history = useHistory()
  const { setLoader, accountObj } = useContext(AppContext)
  const [newProjectModal, setNewProjectModal] = useState(false)
  const [templateId, setTemplateId] = useState('')
  const [deleteModal, setDeleteModal] = useState(false)
  const [customPageNameModal, setCustomPageNameModal] = useState(false)
  const [pagesData, setPagesData] = useState([])
  const [shareModalData, setShareModalData] = useState([])
  const [pageId, setPageId] = useState('')

  const language = localStorage.getItem('language')
  const { userSessionObj } = useContext(GlobalContext)

  const defaultLangCheck = language === accountObj?.default_language
  const isCreateAllowed =
    checkPermissions(userSessionObj.session_data.permissions, PERMISSIONS.WEBSITE.CREATE) &&
    defaultLangCheck

  let isCustomTemplateAllowed = accountObj?.od_resource_allowances?.custom_template
  const [{ data: pagesList, loading: pagesListLoading }, pagesListCall] = useAxios(
    {
      url: CUSTOM_PAGES_API,
      method: 'get',
    },
    { manual: true },
  )
  const [{ data: pageDelete, loading: pageDeleteLoading }, pageDeleteCall] = useAxios(
    {
      url: CUSTOM_PAGES_API,
      method: 'delete',
    },
    { manual: true },
  )

  useEffect(() => {
    setLoader(pagesListLoading || pageDeleteLoading)
  }, [pagesListLoading, pageDeleteLoading])

  useEffect(() => {
    pagesListCall()
  }, [])

  useEffect(() => {
    if (pageDelete && pageDelete.success) {
      setDeleteModal(false)
      raiseToast('success', 'Deleted successfully')
      pagesListCall()
    }
  }, [pageDelete])

  useEffect(() => {
    if (pagesList && pagesList.success) {
      setPagesData(pagesList.data.filter((page) => page?.type === 'CUSTOM'))
    }
  }, [pagesList])

  const cardStyles = {
    width: '21vw',
    height: '16vw',
    borderRadius: '0',
    boxShadow: ' 3px 3px 6px rgba(0,0,0,0.16)',
    aspectRatio: '45/34',
    overflow: 'hidden',
    postion: 'relative',
  }

  const onStartProject = (info) => {
    setNewProjectModal(false)
  }
  const onEdit = (id) => {
    if (!isCustomTemplateAllowed) {
      raiseToast('error', "You don't have Access to Custom Template!")
      return
    }
    if (id) {
      history.push(`/custom-editor/${id}`)
    }
  }

  const shareHandler = (info) => {
    setShareModalData([
      {
        title: 'Page URL',
        data: createPageUrl(accountObj?.domain_name, info?.page_url),
      },
    ])
  }

  const handleDelete = () => {
    if (!isCustomTemplateAllowed) {
      raiseToast('error', "You don't have Access to Custom Template!")
      return
    }
    if (pageId) {
      pageDeleteCall({
        params: {
          custom_page_id: pageId,
        },
      })
    }
  }

  return (
    <>
      {isCustomTemplateAllowed ? (
        <div>
          <h4 style={{ marginTop: '5px' }}>Custom Pages</h4>
          <p style={{ fontSize: '18px', color: '#707070' }}>
            Choose your website template and customize it as per your needs.
          </p>
          <CCard
            className="rounded-0 cards-container scrollbar position-relative"
            style={{
              padding: '4.2%',
            }}
          >
            <CRow xs={{ cols: 3, gutter: 4 }}>
              {pagesData &&
                pagesData?.map((info, idx) => (
                  <CCol key={idx}>
                    <CCard style={cardStyles}>
                      <div className="w-100 h-100 position-relative" style={{ zindex: 0 }}>
                        <CustomImage
                          imageUrl={info?.preview_s3_key?.website}
                          imgClass="w-100 position-absolute"
                          imgStyle={{ borderRadius: '0', zIndex: 0 }}
                          loaderClass="w-100 h-100"
                          loaderStyle={{ background: '#5A5A5A50' }}
                          imgAlt={'thumbnail'}
                        />
                      </div>
                      <div className="template-card-cardBody">
                        <div>
                          <span style={{ fontWeight: '500', color: '#191818', fontSize: '15px' }}>
                            {info?.name}
                          </span>
                          <p style={{ color: '#747272', fontSize: '12px', marginBottom: '5px' }}>
                            {/* Last modified: {moment(info.modified_date).format(' DD MMM YYYY')} */}
                            Last modified: {moment(info?.modified_date).format('DD MMMM YYYY')}
                          </p>
                        </div>
                        <Dropdown align="center" className="">
                          <Dropdown.Toggle variant="ghost" className="" id="revenue-dropdown">
                            <img src={OptionsBtn} alt="OptionsBtn" />
                          </Dropdown.Toggle>

                          <Dropdown.Menu>
                            <Dropdown.Item
                              style={{ cursor: 'pointer' }}
                              onClick={() => shareHandler(info)}
                            >
                              <CIcon icon={cilShareAlt} size="sm" />
                              {'    Share'}
                            </Dropdown.Item>
                            <Dropdown.Item
                              style={{ cursor: 'pointer' }}
                              onClick={() => onEdit(info._id)}
                            >
                              <CIcon icon={cilPencil} size="sm" />
                              {'    Edit'}
                            </Dropdown.Item>
                            <Dropdown.Item
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setPageId(info._id)
                                setDeleteModal(true)
                              }}
                            >
                              <CIcon icon={cilTrash} size="sm" />
                              {'    Delete'}
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </CCard>
                  </CCol>
                ))}

              {/* Data in Above card will come from API */}

              <CCol style={{ cursor: 'pointer' }}>
                <CCard
                  style={{ ...cardStyles, backgroundColor: '#e8e8e8' }}
                  className="flex-column align-items-center justify-content-center"
                  onClick={
                    isCreateAllowed
                      ? isCustomTemplateAllowed
                        ? () => setCustomPageNameModal(true)
                        : () => raiseToast('error', "You don't have Access to Custom Template!")
                      : () => raiseToast('error', 'Creation only allowed in default language!')
                  }
                >
                  <CImage
                    src={AddIcon}
                    style={{
                      marginBottom: '10px',
                    }}
                  />
                  <p style={{ color: '#747272' }}>Add New Page</p>
                </CCard>
              </CCol>
            </CRow>
          </CCard>
          {customPageNameModal && (
            <CustomPageNameModal
              pagesData={pagesData}
              onCancel={() => setCustomPageNameModal(false)}
            />
          )}
          {deleteModal && (
            <DeleteModal
              openModal={deleteModal}
              title={`Are you sure you want to Delete this Page?`}
              confirmButtonText={`Yes`}
              onCancel={() => {
                setPageId('')
                setDeleteModal(false)
              }}
              onConfirm={handleDelete}
            />
          )}
          {!isEmpty(shareModalData) && (
            <ShareModal
              details={shareModalData}
              onClose={() => setShareModalData([])}
              modalTitle={'Share Page'}
            />
          )}
        </div>
      ) : (
        <ServiceNotAllowed />
      )}
    </>
  )
}

export default CustomPageListing
